import * as actions from '../actions/generalProductActionTypes';

const initialState = {
  productList: {
    success: true,
    errors: null,
    warnings: null,
    products: []
  }
};

function generalProduct(state = initialState, action) {
  switch (action.type) {
    case actions.GENERAL_PRODUCTLIST_SET:
      return {
        ...state,
        productList: action.productList
      };
    default:
      return state;
  }
}

export default generalProduct;
